<template>
    <div>
        <!--[if lt IE 7]>
        <p class="alert alert-danger">You are using an <strong>outdated</strong> browser. Please <a
            href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
        <![endif]-->

        <slot/>
    </div>
</template>

<script>

    import HeaderComponent from '../layout/Header.vue'
    import SidebarComponent from '../layout/Sidebar.vue'
    import FooterComponent from '../layout/Footer.vue'

    export default {
        components: {
            HeaderComponent,
            SidebarComponent,
            FooterComponent
        },
        methods: {},
        mounted: function () {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/AnonLayout.vue